import '@/sass/components/_image-lightbox.scss';

/**
 * Image Lightbox functionality for expandable ImageBlock
 * Opens images in a native <dialog> element with backdrop blur
 */
function initImageLightbox(): void {
  const triggers = document.querySelectorAll<HTMLButtonElement>(
    '.image-block-trigger',
  );

  triggers.forEach((trigger) => {
    const dialogId = trigger.dataset.dialog;
    if (!dialogId) return;

    const dialog = document.getElementById(dialogId) as HTMLDialogElement;
    if (!dialog) return;

    const closeButton = dialog.querySelector<HTMLButtonElement>(
      '.image-lightbox-close',
    );

    // Open dialog when trigger is clicked
    trigger.addEventListener('click', () => {
      dialog.showModal();
    });

    // Close dialog when close button is clicked
    closeButton?.addEventListener('click', () => {
      dialog.close();
    });

    // Close dialog when clicking outside the image
    dialog.addEventListener('click', (e) => {
      const target = e.target as HTMLElement;
      if (
        target.tagName !== 'IMG' &&
        !target.closest('.image-lightbox-close')
      ) {
        dialog.close();
      }
    });

    // Close dialog on Escape key (native dialog behavior)
    // This is handled automatically by the browser
  });
}

initImageLightbox();
